import { render } from "./B2bTableDeliveryNotesEmit.vue?vue&type=template&id=7446a330&scoped=true&lang=pug"
import script from "./B2bTableDeliveryNotesEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableDeliveryNotesEmit.vue?vue&type=script&lang=js"

import "./B2bTableDeliveryNotesEmit.vue?vue&type=style&index=0&id=7446a330&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7446a330"]])

export default __exports__